<template>
	<div :id="modalName">
		<b-modal :id="modalName" :title="'Edit Kit - ' + sku" size="lg" scrollable hide-footer>
			<!-- Master Build Info Display -->
			<div v-if="masterBuildInfo" class="master-build-info">
				<b-alert variant="info" show>
					<strong>Master Build:</strong> {{ masterBuildInfo.sku }} - {{ masterBuildInfo.name }}
				</b-alert>
			</div>
            <b-form-row>
                <b-col>
                    <b-form-group
                        id="datepicker-group-date"
                        label="Date:"
                        label-for="datepicker-date"
                        label-size="sm"
                    >
                        <b-form-datepicker
                            id="datepicker-date"
                            v-model="edit.date"
                            class="mb-2"
                            size="sm"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            locale="en"
                        >
                        </b-form-datepicker>
                    </b-form-group>
                </b-col>
                <!-- <b-col>
                    <b-form-group
                        id="input-group-cost"
                        label="Cost:"
                        label-for="input-cost"
                        label-size="sm"
                    >
                        <b-form-input
                            id="input-cost"
                            v-model="edit.cost"
                            type="text"
                            size="sm"
                            autocomplete="off"
                        >
                        </b-form-input>
                    </b-form-group>
                </b-col> -->
                <b-col>
                    <b-form-group
                        id="input-group-qty"
                        label="Quantity:"
                        label-for="input-qty"
                        label-size="sm"
                    >
                        <b-form-input
                            id="input-qty"
                            v-model="edit.qty"
                            type="text"
                            size="sm"
                            autocomplete="off"
                        >
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group
                        id="input-group-location"
                        label="Location:"
                        label-for="input-location"
                        label-size="sm"
                    >
                        <b-form-select
                            id="select-location"
                            v-model="edit.location"
                            :options="Object.keys(getLocations)"
                            size="sm"
                        >
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-form-row>
            <hr>
            <b-table-simple hover small caption-top bordered responsive>
                <b-thead head-variant="dark">
                    <b-tr>
                        <b-th>Component SKU</b-th>
                        <b-th class="text-center">QTY</b-th>
                        <b-th class="text-center">FIFO</b-th>
                        <b-th class="text-center">Total</b-th>
                        <b-th class="text-center">QOH</b-th>
                        <b-th class="text-center">Available</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(comp, index) in edit.components" :key="index">
                        <b-td>{{ comp.item.sku }}</b-td>
                        <b-td class="text-center">{{ comp.qty_previous }}</b-td>
                        <b-td class="text-center">${{ comp.fifo }}</b-td>
                        <b-td class="text-center">${{ (comp.qty_previous * comp.fifo).toFixed(2) }}</b-td>
                        <b-td class="text-center">{{ comp.item.qty_total }}</b-td>
                        <b-td class="text-center">{{ comp.item.qty_available }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td></b-td>
                        <b-td class="text-center"><strong>Total: </strong></b-td>
                        <b-td class="text-center"><strong>${{ fifo }}</strong></b-td>
                        <b-td class="text-center"><strong>${{ totalLineFifo }}</strong></b-td>
                        <b-td></b-td>
                        <b-td></b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <hr>
            <b-button type="submit" variant="success" @click="editKit">
                <span v-if="submitting">
                    <b-spinner small type="grow"></b-spinner>
                    Editing...
                </span>
                <span v-else>Edit</span>
            </b-button>
        </b-modal>
    </div>
</template>

<script>
	export default {
		props: [
            'sku',
            // 'cost',
            'id',
            'referenceId'
        ],

        components: {

        },

		data() {
			return {
                modalName: 'modal-inventory-products-edit-kit',

                edit: {
                    date: '',
                    originalDate: '',
                    // cost: 0.00,
                    location: '',
                    qty: '',
                    master: [],
                    components: [],
                },

                masterBuildInfo: null,
                submitting: 0
			}
		},

		methods: {
            editKit() {
                this.submitting = 1
                let editData = this.edit

                let url = 'api/inventory/products/editkit'
                axios.post(url, {
                    editData
                })
                .then((res) => {
                    this.submitting = 0

                    if (res.data.status == 'Success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Kit Edited', 'SKU: ' + this.edit.sku + ' changed to ' + this.edit.qty + ' quantity successfully!')
                        this.$emit('getRow')
                    } else {
                        this.showAlertBox('error', 'Error Editing Kit', res.data.status)
                    }
                }, () => {
                    this.has_error = true
                })
            },

            getBuild() {
                let url = 'api/inventory/products/getbuild/' + this.referenceId
                axios.get(url, {})
                .then((res) => {
                    this.edit.components = res.data.components
                    this.edit.master = res.data.master[0]
                    this.edit.location = res.data.master[0].location
                    this.edit.qty = res.data.master[0].qty
                    this.edit.date = this.formatDateTimeToDate(res.data.master[0].date)
                    this.edit.originalDate = res.data.master[0].date
                    // this.edit.cost = res.data.master[0].item.lastCost ? res.data.master[0].item.lastCost[0].price : res.data.master[0].item.cost
                    
                    // Store master build information for display
                    this.masterBuildInfo = res.data.masterBuildInfo
                }, () => {
                    this.has_error = true
                })
            }
        },

        computed: {
            fifo() {
                let total = Number(0)
                Object.values(this.edit.components).forEach((line, idx, array) => {
                    total += +line.fifo
                })

                return total.toFixed(2)
            },

            totalLineFifo() {
                let total = Number(0)
                Object.values(this.edit.components).forEach((line, idx, array) => {
                    total += +line.fifo * +line.qty_previous
                })

                return total.toFixed(2)
            }
        },

        mounted() {
            this.getBuild()
        }
	}
</script>

<style lang="scss">
    #modal-inventory-products-edit-kit {
        .modal-dialog {
            min-height: 450px;
        }
        
        .master-build-info {
            margin-bottom: 1rem;
            
            .alert {
                margin-bottom: 0;
                font-size: 0.9rem;
            }
        }
    }
</style>
